export abstract class TableRecord {
  [key: string]: any
  public id?: number
}
